<!-- specialTopic -->
<template>
  <div class="specialTopic">
    <el-form :model="ruleForm" label-width="160px">
      <el-form-item label="导读标题：" prop="specialTopic">
        <el-input v-model="ruleForm.specialTopic" type="text" class="fl" style="width: 50%;" />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'specialTopic',
  data() {
    return {}
  },
  props: {
    ruleForm: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {},
  computed: {},
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped></style>
